import cx from "ui/cx";
import styles from "./IconNotification.module.scss";
import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

interface IconNotificationProps extends SvgIconProps {
  showBadge?: boolean;
}

export default function IconNotification({ showBadge, ...props }: IconNotificationProps) {
  return (
    <div className={cx(styles.wrapper)}>
      <SVGIcon
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className="icon"
      >
        <path
          d="M20.6307 16.5881C20.1 15.675 19.3116 13.0997 19.3116 9.75C19.3116 7.8106 18.5412 5.95064 17.1698 4.57928C15.7985 3.20792 13.9385 2.4375 11.9991 2.4375C10.0597 2.4375 8.19975 3.20792 6.82839 4.57928C5.45703 5.95064 4.68661 7.8106 4.68661 9.75C4.68661 13.1006 3.89723 15.675 3.36661 16.5881C3.25018 16.7875 3.18841 17.014 3.18751 17.2449C3.18661 17.4758 3.24663 17.7028 3.3615 17.903C3.47637 18.1033 3.64203 18.2697 3.84176 18.3855C4.0415 18.5013 4.26824 18.5623 4.49911 18.5625H8.48161C8.61823 19.3964 9.0468 20.1545 9.69079 20.7016C10.3348 21.2486 11.1523 21.549 11.9972 21.549C12.8422 21.549 13.6597 21.2486 14.3037 20.7016C14.9477 20.1545 15.3762 19.3964 15.5129 18.5625H19.4991C19.7298 18.562 19.9563 18.5007 20.1558 18.3848C20.3553 18.2689 20.5207 18.1024 20.6353 17.9022C20.75 17.702 20.8098 17.4751 20.8088 17.2444C20.8079 17.0137 20.7461 16.7874 20.6297 16.5881H20.6307ZM11.9991 20.4375C11.4506 20.4373 10.9181 20.2521 10.4879 19.9119C10.0577 19.5716 9.75475 19.0962 9.62817 18.5625H14.37C14.2435 19.0962 13.9406 19.5716 13.5103 19.9119C13.0801 20.2521 12.5476 20.4373 11.9991 20.4375ZM19.6594 17.3438C19.644 17.3725 19.621 17.3964 19.5928 17.4129C19.5647 17.4295 19.5326 17.438 19.5 17.4375H4.49911C4.46651 17.438 4.43441 17.4295 4.4063 17.4129C4.3782 17.3964 4.35517 17.3725 4.33973 17.3438C4.32328 17.3152 4.31461 17.2829 4.31461 17.25C4.31461 17.2171 4.32328 17.1848 4.33973 17.1562C5.04942 15.9375 5.81161 13.0959 5.81161 9.75C5.81161 8.10897 6.4635 6.53516 7.62389 5.37478C8.78427 4.2144 10.3581 3.5625 11.9991 3.5625C13.6401 3.5625 15.2139 4.2144 16.3743 5.37478C17.5347 6.53516 18.1866 8.10897 18.1866 9.75C18.1866 13.095 18.9497 15.9328 19.6594 17.1562C19.6759 17.1848 19.6845 17.2171 19.6845 17.25C19.6845 17.2829 19.6759 17.3152 19.6594 17.3438Z"
          fill="currentColor"
        />
      </SVGIcon>
      {showBadge && <span className="indicator" />}
    </div>
  );
}
